import React from 'react';
import { ComponentType } from 'react';
import { useLocation, useNavigate, useParams, useOutletContext } from 'react-router-dom';

export function withRouter(Component: ComponentType) {
  function ComponentWithRouterProp(props: any) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const context = useOutletContext();
    return (
      <Component
        {...props}
        router={{ location, navigate, params, context }}
        location={location}
        params={params}
      />
    );
  }

  return ComponentWithRouterProp;
}

export default withRouter;
